import React, { useState, useEffect } from 'react';
import mammoth from 'mammoth';

const WordViewer = ({ base64 } : {base64 : string}) => {
    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        const arrayBuffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
        mammoth
            .convertToHtml({ arrayBuffer })
            .then((result) => setHtmlContent(result.value))
            .catch((err) => console.error('Error processing Word document:', err));
    }, [base64]);

    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default WordViewer;
